/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import React, { useMemo } from "react";
import Layout from "../../../Layouts/Layout";
import LandingPageTeaser from "../../../../components/Teaser/LandingPageTeaser";
import PartnerLogoSection from "../../../../components/Sections/Generic/PartnerLogoSection/PartnerLogoSection";
import AttorneySection from "../../../../components/Sections/Generic/AttorneySection/AttorneySection";
import Container from "../../../../components/Container/Container";
import AlimonyCheckin from "../../../../components/Checkin/FamilyLawCheckin/Alimony/AlimonyCheckin";
import LinkedCardBox from "../../../../components/LinkedCardBox/LinkedCardBox";
import { alimonyTeaserCards } from "@/src/services/landingPageService";
import LpAlimonyAdvoCardMeta from "./AdvoCard/LpAlimonyAdvoCardMeta";
import LpAlimonyAragMeta from "./Arag/LpAlimonyAragMeta";
import { useCustomer } from "@/src/provider/Customer/CustomerProvider";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";
import HowItWorksSectionAlimony from "../../../../components/Sections/FamilyLaw/Alimony/HowItWorksSection/HowItWorksSectionAlimony";
import { PARTNER_IRIS } from "@/src/constants/partnerIris";

const getMetaDataByPartner = ({ partner }: { partner: string }) => {
  switch (partner) {
    case PARTNER_IRIS.ADVOCARD:
      return <LpAlimonyAdvoCardMeta />;
    case PARTNER_IRIS.ARAG:
      return <LpAlimonyAragMeta />;
    default:
      return null;
  }
};

const LpAlimonyPartner = ({ partner }: { partner: NonNullable<AbstractCase["acquisitionPartner"]> }) => {
  const { isLoggedIn } = useCustomer();

  const metaData = useMemo(() => getMetaDataByPartner({ partner }), [partner]);

  return (
    <Layout minimal={!isLoggedIn} clickableLogo={isLoggedIn} backgroundType={"landingpage"}>
      {metaData}
      <LandingPageTeaser
        headline={"Beratung zum Thema Unterhalt"}
        subheadline={"Unterhalt berechnen und professionell beraten lassen"}
        teaserButtonText={"Unterhalt berechnen"}
        teaserButtonLink={isLoggedIn ? "/servicewelt" : "#top-checkin"}
      >
        <LinkedCardBox linkedCards={alimonyTeaserCards} />
      </LandingPageTeaser>
      <PartnerLogoSection partnerIri={partner} containerStyle={"settlementContainer"} />
      {!isLoggedIn && (
        <Container>
          <AlimonyCheckin checkinHeading={"Unterhaltsberechnung erstellen und Erstberatung vereinbaren"} idPrefix={"top"} partner={partner} />
        </Container>
      )}
      <HowItWorksSectionAlimony />
      <AttorneySection
        product={"familyLawCase"}
        subheading={"Sie möchten sich professionell und schnell unterstützen lassen? Wir helfen Ihnen - jederzeit und ortsunabhängig!"}
      />
      {!isLoggedIn && (
        <Container>
          <AlimonyCheckin checkinHeading={"Unterhaltsberechnung erstellen und Erstberatung vereinbaren"} idPrefix={"top"} partner={partner} />
        </Container>
      )}
    </Layout>
  );
};

export default LpAlimonyPartner;
